import React from 'react';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
import { getChinaLocalization } from 'shared/account/reducer';
import Link from 'shared/components/Link';
import { getAvailableNewPlans } from '../reducer';
import { PADDLE_PLAN_TYPES } from '../constants';
var EditingTranslationPlansRowOld = function EditingTranslationPlansRowOld(_ref) {
  var hasActivePlan = _ref.hasActivePlan;
  var user = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user;
  });
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var isChinaUser = useSelector(getChinaLocalization);
  var needsCurrencyConversion = !isChinaUser;
  var _useSelector = useSelector(getAvailableNewPlans),
    availablePremiumWithTranslationPlans = _useSelector.premiumWithTranslation,
    availablePremiumWithEditingOnlyPlans = _useSelector.editing;
  var plans = {
    editing: {
      yearly: availablePremiumWithEditingOnlyPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY;
      }),
      monthly: availablePremiumWithEditingOnlyPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.MONTHLY;
      })
    },
    translation: {
      yearly: availablePremiumWithTranslationPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.YEARLY;
      }),
      monthly: availablePremiumWithTranslationPlans.find(function (plan) {
        return plan.billingInterval === PADDLE_PLAN_TYPES.MONTHLY;
      })
    }
  };
  var PricingInfo = function PricingInfo(_ref3) {
    var yearlyPlan = _ref3.yearlyPlan,
      monthlyPlan = _ref3.monthlyPlan;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "pricing m-0 p-0 pb-1 fw-bold text-center"
    }, price(user.currency, (yearlyPlan === null || yearlyPlan === void 0 ? void 0 : yearlyPlan.price) / 12, true, needsCurrencyConversion), ' '), /*#__PURE__*/React.createElement("p", {
      className: "pricing-extra align-items-center text-center offset-2 col-8 mb-1"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.annual-per-month-billing",
      params: {
        price: price(user.currency, monthlyPlan === null || monthlyPlan === void 0 ? void 0 : monthlyPlan.price, true, needsCurrencyConversion)
      }
    })));
  };
  var PlanCard = function PlanCard(_ref4) {
    var title = _ref4.title,
      pricingComponent = _ref4.pricingComponent,
      featureList = _ref4.featureList,
      actionButton = _ref4.actionButton;
    return /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 d-flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card bg-white mt-4 mt-md-0 flex-grow-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body d-flex flex-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "callout mb-3 font-weight-bold text-center"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-center"
    }, title)), pricingComponent, /*#__PURE__*/React.createElement("div", {
      className: "p-0 m-0 mt-3 d-inline rubriq-plan-feature-list"
    }, featureList), /*#__PURE__*/React.createElement("div", {
      className: "text-center pt-1 mt-auto"
    }, actionButton))));
  };
  var editingPlanCard = /*#__PURE__*/React.createElement(PlanCard, {
    title: /*#__PURE__*/React.createElement(T, {
      source: "curie.curie-premium"
    }),
    pricingComponent: /*#__PURE__*/React.createElement(PricingInfo, {
      yearlyPlan: plans.editing.yearly,
      monthlyPlan: plans.editing.monthly
    }),
    featureList: /*#__PURE__*/React.createElement(T.md, {
      source: "rubriq.premium-editing-feature-list"
    }),
    actionButton: /*#__PURE__*/React.createElement(Link, {
      id: "start_free_trial_btn",
      className: "btn btn-outline-primary",
      to: "/rubriq/plan/subscribe/freetrial"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.get-starter"
    }))
  });
  var translationPlanCard = !hasActivePlan && /*#__PURE__*/React.createElement(PlanCard, {
    title: /*#__PURE__*/React.createElement(T, {
      source: "rubriq.rubriq-premium-with-translation"
    }),
    pricingComponent: /*#__PURE__*/React.createElement(PricingInfo, {
      yearlyPlan: plans.translation.yearly,
      monthlyPlan: plans.translation.monthly
    }),
    featureList: /*#__PURE__*/React.createElement(T.md, {
      source: "rubriq.premium-with-translation-feature-list"
    }),
    actionButton: /*#__PURE__*/React.createElement(Link, {
      id: "start_free_trial_btn",
      className: "btn btn-outline-primary",
      to: "/rubriq/plan/subscribe/premium"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.get-starter"
    }))
  });
  var groupPlanCard = /*#__PURE__*/React.createElement(PlanCard, {
    title: /*#__PURE__*/React.createElement(T, {
      source: "curie.preferred-group"
    }),
    pricingComponent: /*#__PURE__*/React.createElement("p", {
      className: "pricing m-0 p-0 pb-1 fw-bold text-center"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.custom"
    })),
    featureList: /*#__PURE__*/React.createElement(T.md, {
      source: "curie.preferred-group-feature-list"
    }),
    actionButton: /*#__PURE__*/React.createElement("a", {
      "aria-label": t('curie.contact-us'),
      className: "btn btn-outline-primary",
      href: isChinaUser ? 'https://www.aje.cn/group-discounts' : 'https://www.aje.com/group-discounts'
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie.contact-us"
    }))
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "row pb-3"
  }, editingPlanCard, translationPlanCard, groupPlanCard);
};
export default EditingTranslationPlansRowOld;